/// <reference path='../officexdm.ts' />

module OfficeExt.WACUtils {
  // Parse and return the app context information from window name, return null if it doesn't exist.
  export function parseAppContextFromWindowName(skipSessionStorage, windowName): any {
    return OSF.OUtil.parseInfoFromWindowName(skipSessionStorage, windowName, OSF.WindowNameItemKeys.AppContext);
  }
  export function serializeObjectToString(obj): string {
    if (typeof JSON !== "undefined") {
      try {
        return JSON.stringify(obj);
      } catch (ex) {}
    }
    return "";
  }
  export function addHostInfoAsQueryParam(url, hostInfoValue): string {
    if (!url) {
      return null;
    }
    url = url.trim() || "";
    var questionMark = "?";
    var hostInfo = "_host_Info=";
    var ampHostInfo = "&_host_Info=";
    var fragmentSeparator = "#";
    var urlParts = url.split(fragmentSeparator);
    var urlWithoutFragment = urlParts.shift();
    var fragment = urlParts.join(fragmentSeparator);
    var querySplits = urlWithoutFragment.split(questionMark);
    var urlWithoutFragmentWithHostInfo;
    if (querySplits.length > 1) {
      urlWithoutFragmentWithHostInfo = urlWithoutFragment + ampHostInfo + hostInfoValue;
    } else if (querySplits.length > 0) {
      urlWithoutFragmentWithHostInfo = urlWithoutFragment + questionMark + hostInfo + hostInfoValue;
    }
    if (fragment) {
      return [urlWithoutFragmentWithHostInfo, fragmentSeparator, fragment].join("");
    } else {
      return urlWithoutFragmentWithHostInfo;
    }
  }
  export function getDomainForUrl(url): string {
    if (!url) {
      return null;
    }
    var url_parser = OSF.OUtil.parseUrl(url, /*enforceHttps*/ true);
    return url_parser.protocol + "//" + url_parser.host;
  }
  export function shouldUseLocalStorageToPassMessage(): boolean {
    try {
      var osList = ["Windows NT 6.1", "Windows NT 6.2", "Windows NT 6.3", "Windows NT 10.0"];
      var userAgent = window.navigator.userAgent;
      for (var i = 0, len = osList.length; i < len; i++) {
        if (userAgent.indexOf(osList[i]) > -1) {
          return isInternetExplorer();
        }
      }
      return false;
    } catch (e) {
      logExceptionToBrowserConsole("Error happens in shouldUseLocalStorageToPassMessage.", e);
      return false;
    }
  }
  export function isInternetExplorer(): boolean {
    try {
      var userAgent = window.navigator.userAgent;
      return userAgent.indexOf("MSIE ") > -1 || userAgent.indexOf("Trident/") > -1 || userAgent.indexOf("Edge/") > -1;
    } catch (e) {
      logExceptionToBrowserConsole("Error happens in isInternetExplorer.", e);
      return false;
    }
  }
  export function removeMatchesFromLocalStorage(regexPatterns: Array<RegExp>): void {
    // Remove multiple cache items that match a set of regex patterns
    var _localStorage = OSF.OUtil.getLocalStorage();
    var keys = _localStorage.getKeysWithPrefix("");
    for (var i = 0, len = keys.length; i < len; i++) {
      var key = keys[i];
      for (var j = 0, lenRegex = regexPatterns.length; j < lenRegex; j++) {
        if (regexPatterns[j].test(key)) {
          _localStorage.removeItem(key);
          break;
        }
      }
    }
  }
  // A helper function to log exception to the browser console
  export function logExceptionToBrowserConsole(message: string, exception: any): void {
    OsfMsAjaxFactory.msAjaxDebug.trace(message + " Exception details: " + serializeObjectToString(exception));
  }
  export function isTeamsWebView(): boolean {
    const ua: string = navigator.userAgent;
    /* Electron WebView (scoped to Microsoft Teams for now) */
    return /Teams\/((?:(\d+)\.)?(?:(\d+)\.)?(?:(\d+)\.\d+)).* Electron\/((?:(\d+)\.)?(?:(\d+)\.)?(?:(\d+)\.\d+))/.test(
      ua,
    );
  }
  // Do not rename or modify this function without testing SSO for WAC
  // //depot/devmain/msoserviceplatform/src/Browser/App/Packages/AppsForOffice/script/AppsForOfficeSingleSignOnManager.cs
  export function getHostSecure(url: string): string {
    if (typeof url === "undefined" || !url) {
      return undefined;
    }
    let host = undefined;
    const httpsProtocol = "https:";
    try {
      // Note: URL class decodes Unicode escapes
      let urlObj = new URL(url);
      if (urlObj) {
        host = urlObj.host;
      }
      if (!urlObj.protocol) {
        throw "fallback";
      } else if (urlObj.protocol !== httpsProtocol) {
        return undefined;
      }
    } catch (ex) {
      try {
        let parser = document.createElement("a");
        parser.href = url;
        if (parser.protocol !== httpsProtocol) {
          return undefined;
        }
        let match = url.match(new RegExp("^https://[^/?#]+", "i"));
        let naiveMatch = match && match.length == 1 ? match[0].toLowerCase() : "";
        //IE will show parser.host with the port regardless on whether url originally had a port or not
        //For validation, we need to consider both cases
        let parsedUrlWithoutPort = (parser.protocol + "//" + parser.hostname).toLowerCase();
        let parsedUrlWithPort = (parser.protocol + "//" + parser.host).toLowerCase();
        /* This verification is very important for security to avoid having garbage urls passed malliciously and
                document.createElement("a") remaining the current document URL which might be whitlisted. */
        if (parsedUrlWithPort === naiveMatch || parsedUrlWithoutPort == naiveMatch) {
          host = parser.port == "443" ? parser.hostname : parser.host;
        }
      } catch (ex) {
        return undefined;
      }
    }
    return host ? host.toLowerCase() : undefined;
  }
  export class CacheConstants {
    static GatedCacheKeyPrefix = "__OSF_GATED_OMEX.";
    static AnonymousCacheKeyPrefix = "__OSF_ANONYMOUS_OMEX.";
    static UngatedCacheKeyPrefix = "__OSF_OMEX.";
    static ActivatedCacheKeyPrefix = "__OSF_RUNTIME_.Activated.";
    static AppinstallAuthenticated = "appinstall_authenticated.";
    static Entitlement = "entitle.";
    static AppState = "appState.";
    static AppDetails = "appDetails.";
    static AppInstallInfo = "appInstallInfo.";
    static AuthenticatedAppInstallInfoCacheKey =
      CacheConstants.GatedCacheKeyPrefix + CacheConstants.AppinstallAuthenticated + "{0}.{1}.{2}.{3}";
    static EntitlementsKey = CacheConstants.Entitlement + "{0}.{1}";
    static AppStateCacheKey = "{0}" + CacheConstants.AppState + "{1}.{2}";
    static AppDetailKey = "{0}" + CacheConstants.AppDetails + "{1}.{2}";
    static AppInstallInfoKey = "{0}" + CacheConstants.AppInstallInfo + "{1}.{2}";
    static ActivatedCacheKey = CacheConstants.ActivatedCacheKeyPrefix + "{0}.{1}.{2}";
  }
}
namespace OSF {
  export enum OmexRemoveAddinResultCode {
    Success = 0,
    ClientError = 400,
    ServerError = 500,
    UnknownError = 600,
  }
  export enum OmexRemoveAddinMessageKeys {
    RemoveAddinResultCode = "resultCode",
    RemoveAddinResultValue = "resultValue",
  }
  // Keys for json message from omex iframe notification
  export enum OmexMessageKeys {
    MessageType = "messageType",
    MessageValue = "messageValue",
  }
  export enum AuthType {
    Anonymous = 0,
    MSA = 1,
    OrgId = 2,
    ADAL = 3,
  }
  // This is used to construct the omex iframe notification url params
  export enum OmexPageParameterKeys {
    AppName = "client",
    AppVersion = "cv",
    AppUILocale = "ui",
    AppDomain = "appDomain",
    StoreLocator = "rs",
    AssetId = "assetid",
    NotificationType = "notificationType",
    AppCorrelationId = "corr",
    AuthType = "authType",
    AppId = "appid",
    Scopes = "scopes",
  }
  export enum HostThemeButtonStyleKeys {
    ButtonBorderColor = "buttonBorderColor",
    ButtonBackgroundColor = "buttonBackgroundColor",
  }
  // This is used in DialogActions.ts and wac host
  export enum ShowWindowDialogParameterKeys {
    Url = "url",
    Width = "width",
    Height = "height",
    DisplayInIframe = "displayInIframe",
    HideTitle = "hideTitle",
    UseDeviceIndependentPixels = "useDeviceIndependentPixels",
    PromptBeforeOpen = "promptBeforeOpen",
    EnforceAppDomain = "enforceAppDomain",
    UrlNoHostInfo = "urlNoHostInfo",
  }
}
